import ApiClient from './ApiClient';

class AvailabilityAPI extends ApiClient {
  constructor() {
    super('availability_reasons', { accountScoped: true });
  }
}

export default new AvailabilityAPI();
